import { Link } from '@tanstack/react-router';
import { TagBadge } from '@chatsdet/ui';
import { Camera } from '@phosphor-icons/react';
import { useVisualSummary } from '../../../features/visual/useVisual';
import {
  visualChangesBadgeText,
  visualScopeToSearch,
  type VisualScope,
} from '../../../features/visual/visualSearch';

/** "N visual changes" link into /visual for one run; renders nothing without changes or sandboxV2. */
export function VisualChangesBadge({ scope }: { scope: VisualScope }) {
  const summary = useVisualSummary(scope);
  const changed = summary.data?.changed ?? 0;
  if (changed <= 0) return null;
  return (
    <Link to="/visual" search={visualScopeToSearch(scope)} aria-label="Review visual changes">
      <TagBadge name={visualChangesBadgeText(changed)} color="orange" size="md" icon={<Camera size={12} />} />
    </Link>
  );
}
